import React, { useState, useEffect } from 'react';
import useSWR, { mutate } from 'swr';

import EditIcon from './assets/images/edit-icon.svg';
import DeleteIcon from './assets/images/delete-icon.svg';
import PlusIcon from './assets/images/plus-icon.svg';

const parseResponseData = async (response) => {
    const contentType = response.headers.get('content-type') || '';
    if (contentType.includes('application/json')) {
        return response.json();
    }

    const rawText = await response.text();
    return {
        hata: rawText?.trim()
            ? `Sunucudan JSON yerine beklenmeyen bir yanit dondu: ${rawText.slice(0, 120)}`
            : 'Sunucudan JSON yerine bos veya gecersiz bir yanit dondu.'
    };
};

// SWR için gerekli basit fetcher fonksiyonu
const fetcher = url => {
    const token = localStorage.getItem('token');

    return fetch(url, {
        headers: {
            'Authorization': `Bearer ${token}`
        }
    }).then(res => {
        if (!res.ok) {
            const error = new Error('Yetkilendirme hatası veya sunucuya ulaşılamadı.');
            error.info = res.statusText;
            error.status = res.status;
            throw error;
        }
        return res.json();
    });
};


// --- KULLANICI EKLEME/DÜZENLEME FORMU MODAL'I (GÜNCELLENDİ) ---
function KullaniciFormModal({ isOpen, onClose, kullanici, onSave }) {
    const [formData, setFormData] = useState({ kullanici_adi: '', gorunen_ad: '', sifre: '', rol: 'operator' });
    const isEditing = kullanici && kullanici.id;

    useEffect(() => {
        if (isOpen) {
            if (isEditing) {
                setFormData({
                    kullanici_adi: kullanici.kullanici_adi || '',
                    gorunen_ad: kullanici.gorunen_ad || '',
                    sifre: '',
                    rol: kullanici.rol || 'operator', // Mevcut kullanıcının rolünü seçili getir
                });
            } else {
                // Yeni kullanıcı için formu sıfırla
                setFormData({ kullanici_adi: '', gorunen_ad: '', sifre: '', rol: 'operator' });
            }
        }
    }, [kullanici, isOpen, isEditing]);

    if (!isOpen) return null;

    const handleChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        onSave(formData, kullanici?.id);
    };

    return (
        <div style={{ position: 'fixed', top: 0, left: 0, width: '100%', height: '100%', background: 'rgba(0,0,0,0.5)', display: 'flex', justifyContent: 'center', alignItems: 'center', zIndex: 1000 }}>
            <div style={{ background: 'white', padding: '25px', borderRadius: '8px', width: '400px' }} onClick={e => e.stopPropagation()}>
                <form onSubmit={handleSubmit}>
                    <h3 style={{ marginTop: 0 }}>{isEditing ? 'Kullanıcı Düzenle' : 'Yeni Kullanıcı Ekle'}</h3>
                    
                    <div style={{ marginBottom: '15px' }}>
                        <label>Kullanıcı Adı:</label>
                        <input type="text" name="kullanici_adi" value={formData.kullanici_adi} onChange={handleChange} required style={{ width: '100%', padding: '8px', boxSizing: 'border-box' }} />
                    </div>
                    
                    <div style={{ marginBottom: '15px' }}>
                        <label>Görünecek Ad:</label>
                        <input type="text" name="gorunen_ad" value={formData.gorunen_ad} onChange={handleChange} required style={{ width: '100%', padding: '8px', boxSizing: 'border-box' }} />
                    </div>

                    {/* --- YENİ ROL SEÇİMİ ALANI --- */}
                    <div style={{ marginBottom: '15px' }}>
                        <label>Rol:</label>
                        <select 
                            name="rol" 
                            value={formData.rol} 
                            onChange={handleChange}
                            style={{ width: '100%', padding: '8px', boxSizing: 'border-box', background: 'white', border: '1px solid #ccc' }}
                        >
                            <option value="operator">Genel Operatör</option>
                            <option value="satis_operatoru">Satış Operatörü</option>
                            <option value="depo_operatoru">Depo Operatörü</option>
                            <option value="admin">Admin (Tüm Yetkiler)</option>
                        </select>
                    </div>
                    {/* ------------------------------------- */}

                    <div style={{ marginBottom: '15px' }}>
                        <label>Şifre:</label>
                        <input type="password" name="sifre" value={formData.sifre} onChange={handleChange} placeholder={isEditing ? 'Değiştirmek için yeni şifre girin' : ''} required={!isEditing} style={{ width: '100%', padding: '8px', boxSizing: 'border-box' }} />
                    </div>

                    <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '10px' }}>
                        <button type="button" onClick={onClose}>Vazgeç</button>
                        <button type="submit">{isEditing ? 'Güncelle' : 'Kaydet'}</button>
                    </div>
                </form>
            </div>
        </div>
    );
}


// --- ANA KULLANICI YÖNETİMİ COMPONENT'İ (Değişiklik yok) ---
function KullaniciYonetimi() {
    const { data: kullanicilar, error } = useSWR('/api/yonetim/kullanicilar', fetcher);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [seciliKullanici, setSeciliKullanici] = useState(null);

    const handleOpenModal = (kullanici = null) => {
        setSeciliKullanici(kullanici);
        setIsModalOpen(true);
    };

    const handleSaveKullanici = async (formData, kullaniciId) => {
        const isEditing = !!kullaniciId;
        const endpoint = isEditing ? `/api/yonetim/kullanicilar/${kullaniciId}` : '/api/yonetim/kullanicilar';
        const method = isEditing ? 'PUT' : 'POST';
        const token = localStorage.getItem('token');

        try {
            const response = await fetch(endpoint, {
                method: method,
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${token}`
                },
                body: JSON.stringify(formData)
            });
            const data = await parseResponseData(response);
            if (!response.ok) throw new Error(data.hata);
            
            alert(data.mesaj);
            setIsModalOpen(false);
            mutate('/api/yonetim/kullanicilar'); // Listeyi otomatik yenile
        } catch (error) {
            alert(`Hata: ${error.message}`);
        }
    };
    
    const handleDeleteKullanici = async (kullaniciId) => {
        if (!window.confirm("Bu kullanıcıyı silmek istediğinizden emin misiniz?")) return;
        const token = localStorage.getItem('token');

        try {
            const response = await fetch(`/api/yonetim/kullanicilar/${kullaniciId}`, {
                method: 'DELETE',
                headers: {
                    'Authorization': `Bearer ${token}`
                }
            });
            const data = await parseResponseData(response);
            if (!response.ok) throw new Error(data.hata);
            alert(data.mesaj);
            mutate('/api/yonetim/kullanicilar');
        } catch (error) {
            alert(`Hata: ${error.message}`);
        }
    };
    
    if (error) return <div>Veri yüklenirken hata oluştu.</div>;
    if (!kullanicilar) return <div>Yükleniyor...</div>;

    return (
        <div style={{ padding: '20px' }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px' }}>
                <h2>Kullanıcı Yönetimi</h2>
                <button onClick={() => handleOpenModal()} 
                    style={{ padding: '5px 15px', display: 'flex', alignItems: 'center', gap: '8px', cursor: 'pointer', border: '1px solid #ccc', borderRadius: '4px', fontFamily: 'poppins' }}>
                    <img src={PlusIcon} alt="Yeni" style={{ height: '14px' }} />
                    <span>Yeni Kullanıcı</span>
                </button>
            </div>
            <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                <thead>
                    <tr style={{ background: '#f2f2f2' }}>
                        <th style={{padding: '12px', textAlign: 'left'}}>ID</th>
                        <th style={{padding: '12px', textAlign: 'left'}}>Kullanıcı Adı</th>
                        <th style={{padding: '12px', textAlign: 'left'}}>Görünecek Ad</th>
                        <th style={{padding: '12px', textAlign: 'left'}}>Rol</th>
                        <th style={{padding: '12px', textAlign: 'center'}}>İşlemler</th>
                    </tr>
                </thead>
                <tbody>
                    {kullanicilar.map(user => (
                        <tr key={user.id} style={{ borderBottom: '1px solid #ddd' }}>
                            <td style={{padding: '12px'}}>{user.id}</td>
                            <td style={{padding: '12px'}}>{user.kullanici_adi}</td>
                            <td style={{padding: '12px'}}>{user.gorunen_ad}</td>
                            <td style={{padding: '12px'}}>{user.rol}</td>
                            <td style={{padding: '12px', textAlign: 'center'}}>
                                <button onClick={() => handleOpenModal(user)} style={{ background: 'none', border: 'none', cursor: 'pointer', marginRight: '10px' }}><img src={EditIcon} alt="Düzenle" style={{ width: '16px' }} /></button>
                                <button onClick={() => handleDeleteKullanici(user.id)} style={{ background: 'none', border: 'none', cursor: 'pointer' }}><img src={DeleteIcon} alt="Sil" style={{ width: '16px' }} /></button>
                            </td>
                        </tr>
                    ))}
                </tbody>
            </table>
            <KullaniciFormModal 
                isOpen={isModalOpen}
                onClose={() => setIsModalOpen(false)}
                kullanici={seciliKullanici}
                onSave={handleSaveKullanici}
            />
        </div>
    );
}

export default KullaniciYonetimi;